import * as React from 'react';

import { Button } from '@cian/button-component';

import { IModerationVerificationSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { WarningIcon } from './WarningIcon';
import { trackCheckAdClick } from './tracking';

import * as styles from './index.css';

export interface IModerationVerificationStoreProps {
  moderationVerification: IModerationVerificationSchema;
  offerUserId: number | null;
  offerId: number | null;
  userId: number | null;
  publishedUserId: number | null;
}

export type IModerationVerificationProps = IModerationVerificationStoreProps;

export class ModerationVerification extends React.Component<IModerationVerificationProps, {}> {
  public render() {
    const { moderationVerification, offerId } = this.props;
    const enabled = moderationVerification && moderationVerification.enabled;
    const constraint = moderationVerification && moderationVerification.constraint;
    const constraintId = constraint && constraint.announcementId;
    const message = moderationVerification && moderationVerification.constraint
      && moderationVerification.constraint.text;

    const isCurrentUserOwnerOffer = this.props.publishedUserId === this.props.userId ||
      this.props.offerUserId === this.props.userId;

    if (!isCurrentUserOwnerOffer) {
      return null;
    }

    if (constraintId !== offerId) {
      return null;
    }

    if (!enabled || !constraint) {
      return null;
    }

    const isButtonVisible = constraint.state === 'inProgress' || (constraint.state === 'failed' && constraint.canRetry);

    if (!message) {
      return null;
    }

    return (
      <div className={styles['container']}>
        <div className={styles['message']}>
          <div className={styles['icon']}><WarningIcon /></div>
          {message}
        </div>
        {isButtonVisible &&
          <div className={styles['button']}>
            <Button
              onClick={this.handleButtonClick}
            >
              Пройти проверку
            </Button>
          </div>
        }
      </div>
    );
  }

  private handleButtonClick = () => {
    trackCheckAdClick();
    window.location.assign('/verification/');
  }
}
